import React from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import {DescriptionList} from 'components/DescriptionList';
import {DownloadPermissionField, SubtitlesField} from 'components/FormFields';
import FormStack from 'components/FormStack';

import FileNameDescription from '../Descriptions/FileNameDescription';
import FileSizeDescription from '../Descriptions/FileSizeDescription';
import LastUpdatedDescription from '../Descriptions/LastUpdatedDescription';
import AssetLibraryDescription from '../Descriptions/AssetLibraryDescription';

import DividerPanel from './DividerPanel';
import ProcessingAlert from './ProcessingAlert';

import {ASSET_WRITE, hasPrivilege} from 'utils/privileges';

const VideoDetailsPanel = ({
	isEditMode,
	isNewFile,
	isProcessingError,
	uploadProgress,
	showUploadProgress,
	content,
	fields,
	onReplace,
	onDelete,
}) => {
	const hasAssetPermissions = hasPrivilege(ASSET_WRITE);
	const {id, size, fileName} = content;
	const {lastUpdated, download, subtitles, parentId} = fields;

	const {t} = useTranslation();

	return (
		<DividerPanel header={t('content_type_video_details')}>
			<FormStack spacing="m">
				{isProcessingError && (
					<ProcessingAlert
						isEditMode={isEditMode}
						fileName={fileName}
						onReplace={onReplace}
						onDelete={onDelete}
					/>
				)}
				<DescriptionList titleWidth={1 / 4}>
					<FileNameDescription
						isEditMode={isEditMode}
						isNewFile={isNewFile}
						assetId={id}
						fileName={fileName}
						onReplace={onReplace}
					/>
					<FileSizeDescription
						showUploadProgress={showUploadProgress}
						size={size}
						uploadProgress={uploadProgress}
					/>
					<LastUpdatedDescription lastUpdated={lastUpdated?.value} />
					{hasAssetPermissions && (
						<AssetLibraryDescription
							content={content}
							updateFolderLocation={value => parentId.set(value)}
							folderId={parentId.value}
						/>
					)}
				</DescriptionList>

				<DownloadPermissionField
					bold={false}
					download={download.value}
					onChange={value => download.set(value)}
				/>

				<SubtitlesField
					isHorizontal={false}
					assetId={id}
					subtitles={subtitles.value}
					onChange={value => subtitles.set(value)}
				/>
			</FormStack>
		</DividerPanel>
	);
};

export default VideoDetailsPanel;

VideoDetailsPanel.propTypes = {
	isEditMode: PropTypes.bool,
	isNewFile: PropTypes.bool,
	isProcessingError: PropTypes.bool,
	showUploadProgress: PropTypes.bool,
	uploadProgress: PropTypes.number,
	content: PropTypes.object,
	fields: PropTypes.object,
	onReplace: PropTypes.func,
	onDelete: PropTypes.func,
};
